import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Table,
  Space,
  Modal,
  Layout,
  Form,
  Input,
  Select,
  Badge,
  notification
} from "antd";
import { Link } from "react-router-dom";
import Highlighter from "react-highlight-words";
import {
  EditOutlined,
  UserAddOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { getAccounts, updateAccount, deleteAccount } from "../../redux/account/action";

const { Content } = Layout;
const { Option } = Select;

function Account() {
  const dispatch = useDispatch();
  const { accounts } = useSelector((state) => state.account);
  const [isEditModalVisible, setEditModalVisible] = useState(false);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [rowData, setRowData] = useState({});
  const [status, setStatus] = useState(null);
  const [accountModal, setAccountModal] = useState({});

  useEffect(() => {
    dispatch(getAccounts());
  }, []);  

  const handleChange = (e) => {
    setRowData({ ...rowData, [e.target.name]: e.target.value });
  };

  function handleChangeStatus(value) {
    setStatus(value);
  }

  // Handle edit modal
  const showEditModal = (record) => {
    setEditModalVisible(true);
    setRowData(record);
    setStatus(record.status);
    setEditModalVisible(true);
  };

  const handleEditModalCancel = () => {
    setAccountModal({});
    setEditModalVisible(false);
  };

  // Handle delete modal
  const showDeleteModal = (record) => {
    setDeleteModalVisible(true);
    setRowData(record);
  };

  const handleDeleteModalCancel = () => {
    setDeleteModalVisible(false);
  };

  const handleDelete = (id) => {
    dispatch(deleteAccount(id));
    setRowData({});
    setDeleteModalVisible(false);
  };

  const openNotification = (placement, message) => {
    notification.error({
      message: message,
      description: ``,
      placement,
    });
  };

  // handle update
  const handleUpdate = () => {
    const { bankName, accountName, accountNumber } = rowData;
    if (bankName === "") {
      openNotification("topRight", "Bank Name is Required");
    } else if (accountName === "") {
      openNotification("topRight", "Account Name is Required");
    } else if (accountNumber === "") {
      openNotification("topRight", "Account Number is Required");
    } else {
      const formData = {
        id: rowData.id,
        bankName,
        accountName,
        accountNumber,
        status,
      };
      dispatch(updateAccount(rowData.id, formData));
      setRowData({})
      setEditModalVisible(false);
    }
  } 

  // TODO searching and sorting table functionality for Conductors page
  const [searchText, setSearchText] = useState(false);
  const [searchedColumn, setSearchedColumn] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [filteredInfo, setFilteredInfo] = useState(null);
  const [sortedInfo, setSortedInfo] = useState(null);
  let getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setSearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>

          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => setSearchInput(""), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  let handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  let handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
    setFilteredInfo(null);
    setSortedInfo(null);
  };

  // Columns data
  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Bank Name",
      dataIndex: "bankName",
      key: "bankName",
      ...getColumnSearchProps("bankName"),
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
      key: "accountName",
      ...getColumnSearchProps("accountName"),
    },
    {
      title: "Account Number",
      dataIndex: "accountNumber",
      key: "accountNumber",
      ...getColumnSearchProps("accountNumber"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        const active = (
          <Badge
            className="site-badge-count-109"
            count={"Active"}
            style={{ backgroundColor: "#52c41a" }}
          />
        );

        const inactive = <Badge count={"Cancelled"} />;

        const show = record.status === "ACTIVE" ? active : inactive;

        return show;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            style={{ background: "#eba134", borderColor: "#eba134" }}
            type="primary"
            shape="round"
            icon={<EditOutlined />}
            size="small"
            onClick={() => showEditModal(record)}
          />
          <Button
            style={{ background: "#db0925", borderColor: "#db0925" }}
            shape="round"
            type="primary"
            icon={<DeleteOutlined />}
            size="small"
            onClick={() => showDeleteModal(record)}
          />
        </Space>
      ),
    },
  ];
  
  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Bank Accounts Information"
            extra={
              <Link to="new-bank">
                <Button type="primary" icon={<UserAddOutlined />} size="large">
                  Add Bank
                </Button>
              </Link>
            }
          >
            <div
              style={{
                display: "flex",
                padding: "2em 2em 2em 2em",
                width: "100%",
              }}
            >
              <Table
                style={{ width: "100%" }}
                dataSource={accounts}
                columns={columns}                
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/*
        Edit Conductor Modal
      */}
      <Modal
        title="Edit Account"
        visible={isEditModalVisible}
        onCancel={handleEditModalCancel}
        footer={[
          <Button key="back" onClick={handleEditModalCancel}>
            cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleUpdate}>
            Update
          </Button>,
        ]}
        width={1000}
      >
        <Content className="p-0">
          <Row>
            <Col
              xs="8"
              xl={8}
              style={{
                padding: "1em",
              }}
            >
              <Input
                className="bankName"
                label="Bank Name"
                name="bankName"
                placeholder={rowData.bankName}
                value={rowData.bankName}
                onChange={handleChange}
              />
            </Col>
            <Col
              xs={8}
              xl={8}
              style={{
                padding: "1em",
              }}
            >
              <Input
                className="accountName"
                label="Account Name"
                name="accountName"
                placehoder={rowData.accountName}
                value={rowData.accountName}
                onChange={handleChange}
              />
            </Col>
            <Col
              xs={8}
              xl={8}
              style={{
                padding: "1em",
              }}
            >
              <Input
                className="accountNumber"
                label="Account Number"
                name="accountNumber"
                placeholder={rowData.accountNumber}
                onChange={handleChange}
                value={rowData.accountNumber}
              />
            </Col>
          </Row>

          <Row>
            <Col
              xs="8"
              xl={8}
              style={{
                padding: "1em",
              }}
            >
              <Select
                className="status"
                label="Status"
                name="status"
                style={{ width: "100%" }}
                onChange={handleChangeStatus}
                value={status}
              >
                <Option value="ACTIVE">Active</Option>
                <Option value="INACTIVE">InActive</Option>
              </Select>
            </Col>
          </Row>
        </Content>
      </Modal>

      {/*
        Delete Conductor Modal
      */}
      <Modal
        title="Delete Account"
        visible={isDeleteModalVisible}
        onCancel={handleDeleteModalCancel}
        footer={[
          <Button key="back" onClick={handleDeleteModalCancel}>
            cancel
          </Button>,
          <Button key="submit" danger type="primary" onClick={() => handleDelete(rowData.id)}>
            Delete
          </Button>,
        ]}
      >
        <p>Are you sure?</p>
        <p>you want to delete the following Account ?</p>
        <p>{rowData.accountName}</p>
      </Modal>
    </div>
  );
}

export default Account;
